import { AllHTMLAttributes } from 'react';

export interface InsertedElement extends HTMLElement {
    readyState?: string;
    onreadystatechange?: (this: GlobalEventHandlers, ev: Event) => void;
}

const prependParentNode = async <T extends InsertedElement>(
    tagName: string,
    attributes: AllHTMLAttributes<T> = {},
    dataAttributes: DOMStringMap = {},
    context: Window = window
) =>
    new Promise<T>((resolve, reject) => {
        const tag = context.document.getElementsByTagName(tagName)[0];
        const element = context.document.createElement(tagName) as InsertedElement;

        Object.keys(attributes).forEach((key) => {
            // @ts-expect-error $TSFixMeError: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'InsertedElement'.
            element[key] = attributes[key];
        });

        Object.keys(dataAttributes).forEach((key) => {
            element.dataset[key] = dataAttributes[key];
        });

        // Note: onload will be called even if the external script encounters an error after load.
        element.onload = () => {
            if (!element.readyState || element.readyState === 'complete') {
                resolve(element as T);
            }
        };
        element.onreadystatechange = element.onload;

        element.onerror = () => {
            reject(new Error(`Loading of ${attributes.src} to tag <${tagName}> failed`));
        };

        element.onabort = () => {
            reject(new Error(`Loading of ${attributes.src} to tag <${tagName}> was aborted`));
        };

        if (tag && tag.parentNode) {
            tag.parentNode.insertBefore(element, tag);
        } else {
            context.document.head.append(element);
        }
    });

export default prependParentNode;
